/*
 * Created on Wed Aug 09 2023
 *
 * Project: BKN_FRONT
 * Copyright (c) 2023 Nttdata
 */
import React, { useState } from "react";

import moment from "moment";
import toast from "react-hot-toast";

import fetchData from "../../../../libs/client/httpClient";
import { URL_BKI, APP_JSON } from "../../../../constants/URL";

/* COMPONENTES MUI */
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

/* ICONOS */
import UndoIcon from "@mui/icons-material/Undo";
import AnnouncementIcon from "@mui/icons-material/Announcement";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import ReplayIcon from "@mui/icons-material/Replay";
import InfoIcon from "@mui/icons-material/Info";
import { Chip, Typography } from "@mui/material";

const TRANSLATE = "translate(-50%, -50%)";
const BG_PAPER = "background.paper";
const PX_SOLID = "2px solid #000";
const BREAK_WORD = "break-word";

// Componente separado para el contenido del renderCell
function CellValorTrazabilidad({ valor }) {
  const styleModal = {
    position: "absolute",
    top: "40%",
    left: "50%",
    transform: TRANSLATE,
    width: "50%",
    bgcolor: BG_PAPER,
    border: PX_SOLID,
    boxShadow: 24,
    overflow: "auto",
    maxHeight: "350px",
    p: 4,
  };
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  if (valor != null) {
    return (
      <div style={{ textAlign: "left" }}>
        {valor.length > 100 ? (
          <>
            <IconButton
              color="primary"
              aria-label="upload picture"
              component="label"
              onClick={handleClick}
            >
              <InfoIcon />
            </IconButton>
            <Modal open={open} onClose={handleClose}>
              <Box sx={{ ...styleModal }}>
                <div
                  style={{
                    textAlign: "right",
                    wordWrap: BREAK_WORD,
                    overflowWrap: BREAK_WORD,
                  }}
                >
                  <Button
                    variant="contained"
                    startIcon={<UndoIcon />}
                    onClick={handleClose}
                    color="inherit"
                    sx={{ marginTop: "20px" }}
                  >
                    Tornar
                  </Button>
                </div>
                <h2>VALOR:</h2>
                {valor}
              </Box>
            </Modal>
          </>
        ) : (
          <p>{valor}</p>
        )}
      </div>
    );
  } else {
    return null; // Si el valor es null, no se renderiza nada
  }
}

function CellErrorTrazabilidad({ valor }) {
  //Estilos MODAL
  const styleModal = {
    position: "absolute",
    top: "40%",
    left: "50%",
    transform: TRANSLATE,
    width: "50%",
    bgcolor: BG_PAPER,
    border: PX_SOLID,
    boxShadow: 24,
    p: 4,
  };
  const [open, setOpen] = useState(false);
  const handleClick = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  if (valor != null) {
    return (
      <>
        <IconButton
          color="error"
          aria-label="upload picture"
          component="label"
          onClick={handleClick}
        >
          <AnnouncementIcon />
        </IconButton>

        <Modal open={open} onClose={handleClose}>
          <Box sx={styleModal}>
            <h2>Descripció de l'error:</h2>
            <p
              style={{
                overflowWrap: BREAK_WORD,
                wordWrap: BREAK_WORD,
                hyphens: "auto",
              }}
            >
              {valor}
            </p>
            <Button
              variant="contained"
              startIcon={<UndoIcon />}
              onClick={handleClose}
              color="inherit"
              sx={{ marginTop: "20px" }}
            >
              Tornar
            </Button>
          </Box>
        </Modal>
      </>
    );
  }
}

// function CellPeticioTrazabilidad({ valor }) {
//   //Estilos MODAL
//   const styleModal = {
//     position: "absolute",
//     top: "40%",
//     left: "50%",
//     transform: TRANSLATE,
//     width: "50%",
//     bgcolor: BG_PAPER,
//     border: PX_SOLID,
//     boxShadow: 24,
//     p: 4,
//   };
//   const [open, setOpen] = useState(false);
//   const handleClick = () => {
//     setOpen(true);
//   };
//   const handleClose = () => {
//     setOpen(false);
//   };

//   if (valor != null) {
//     return (
//       <>
//         <IconButton
//           color="primary"
//           aria-label="upload picture"
//           component="label"
//           onClick={handleClick}
//         >
//           <CloudDownloadIcon />
//         </IconButton>

//         <Modal open={open} onClose={handleClose}>
//           <Box sx={styleModal}>
//             <h2>Dades per la peticio:</h2>
//             <p
//               style={{
//                 overflowWrap: BREAK_WORD,
//                 wordWrap: BREAK_WORD,
//                 hyphens: "auto",
//               }}
//             >
//               {valor}
//             </p>
//             <Button
//               variant="contained"
//               startIcon={<UndoIcon />}
//               onClick={handleClose}
//               color="inherit"
//               sx={{ marginTop: "20px" }}
//             >
//               Tornar
//             </Button>
//           </Box>
//         </Modal>
//       </>
//     );
//   }
// }

function CellRetornTrazabilidad({ valor }) {
  //Estilos MODAL
  const styleModal = {
    position: "absolute",
    top: "40%",
    left: "50%",
    transform: TRANSLATE,
    width: "50%",
    bgcolor: BG_PAPER,
    border: PX_SOLID,
    boxShadow: 24,
    p: 4,
  };

  const [open, setOpen] = useState(false);
  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  if (valor != null) {
    return (
      <>
        <IconButton
          color="primary"
          aria-label="upload picture"
          component="label"
          onClick={handleClick}
        >
          <CloudDownloadIcon />
        </IconButton>

        <Modal open={open} onClose={handleClose}>
          <Box sx={styleModal}>
            <h2>Dades de retorn ID:</h2>
            <p
              style={{
                overflowWrap: BREAK_WORD,
                wordWrap: BREAK_WORD,
                hyphens: "auto",
              }}
            >
              {valor}
            </p>
            <Button
              variant="contained"
              startIcon={<UndoIcon />}
              onClick={handleClose}
              color="inherit"
              sx={{ marginTop: "20px" }}
            >
              Tornar
            </Button>
          </Box>
        </Modal>
      </>
    );
  }
}

function CellReiniciarReintents({ trazaId, onReintentsReset }) {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    setLoading(true);

    const { data, error } = await fetchData(
      `${URL_BKI.REINICIAR_REINTENTS}${trazaId}`,
      {
        method: "GET",
        config: {
          headers: {
            "Content-Type": APP_JSON,
            Accept: APP_JSON,
          },
        },
      }
    );

    setLoading(false);

    if (error) {
      console.error("Error reiniciar reintents:", error);
      toast.error("Error al reiniciar reintents");
      return;
    }

    const success = data === true;
    if(success){
      toast.success("S'han reiniciat els reintents, pròximament es tornarà a intentar l'enviament a tercers");
      // Actualizar el estado de la fila sin necesidad de F5
      if (onReintentsReset) {
        onReintentsReset(trazaId, 0);
      }
    }else{
      toast.error("Error al reiniciar reintents");
    }
  };

  return (
    <IconButton
      color="primary"
      aria-label="Reiniciar Reintents"
      onClick={handleClick}
      disabled={loading}
    >
      <ReplayIcon />
    </IconButton>
  );
}

export const columnsProperties = [
  {
    field: "GRUP",
    headerName: "GRUP",
    width: 200,
    flex: 1,
    editable: false,
  },
  {
    field: "CLAU",
    headerName: "CLAU",
    width: 350,
    flex: 1,
    editable: false,
  },
  {
    field: "VALOR",
    headerName: "VALOR",
    width: 650,
    flex: 2,
    editable: false,
  },
];

export const columnsReact = [
  {
    field: "ID",
    headerName: "ID",
    width: 300,
    editable: false,
  },
  {
    field: "COMPONENTE",
    headerName: "COMPONENTE",
    width: 450,
    editable: false,
  },
  {
    field: "AUTOR",
    headerName: "AUTOR",
    width: 450,
    editable: false,
  },
];

export const columnsMetataulaDetall = [
  {
    field: "idPeticio",
    headerName: "ENV_ID_PET_XML",
    width: 450,
    renderCell: (params) => {
      return <div className="ajustar-fila">{params.row.idPeticio}</div>;
    },
  },
  {
    field: "Servei",
    headerName: "ENV_SERVEI_PICA",
    width: 350,
    editable: false,
    renderCell: (params) => {
      return <div className="ajustar-fila">{params.row.serveiPica}</div>;
    },
  },
  {
    field: "DataAlta",
    headerName: "ENV_ESTAT",
    width: 150,
    editable: false,
    renderCell: (params) => {
      return (
        <div className="ajustar-fila">
          {params.row.dataAlta.substring(0, 10)}
        </div>
      );
    },
  },

  {
    field: "idNotificacio",
    headerName: "ENV_ID_RES",
    width: 150,
    editable: false,
    renderCell: (params) => {
      return <div className="ajustar-fila">{params.row.idNotificacio}</div>;
    },
  },
  {
    field: "estat",
    headerName: "ESTAT PICA",
    width: 250,
    editable: false,
    renderCell: (params) => {
      return <div className="ajustar-fila">{params.row.estatNotificacio}</div>;
    },
  },
  {
    field: "ENV_ID_MIT",
    headerName: "ENV_ID_MIT",
    width: 150,
    editable: false,
    renderCell: (params) => {
      return <div className="ajustar-fila">{params.row.idMit}</div>;
    },
  },
  {
    field: "ID_OCURRENCIA",
    headerName: "ID_OCURRENCIA",
    width: 200,
    editable: false,
    renderCell: (params) => {
      return <div className="ajustar-fila">{params.row.idOcurrencia}</div>;
    },
  },
  {
    field: "pathGTFuser",
    headerName: "pathGTFuser",
    width: 200,
    editable: false,
    renderCell: (params) => {
      return <div className="ajustar-fila">{params.row.pathGTFuser}</div>;
    },
  },
];

export const columnsLogsEnviamentsPRE = [
  {
    field: "ENV_DATA_ALTA_FITXER",
    headerName: "DATA",
    width: 100,
    renderCell: (params) => {
      const dateString = params.row.ENV_DATA_ALTA_FITXER;
      const nuevaFecha = moment(dateString).format("DD/MM/YYYY"); // "14/03/2023"
      return <div className="ajustar-fila">{nuevaFecha}</div>;
    },
  },
  {
    field: "ENV_ID_PET_XML",
    headerName: "PETICIO XML",
    width: 450,
    renderCell: (params) => {
      return <div className="ajustar-fila">{params.row.ENV_ID_PET_XML}</div>;
    },
  },

  {
    field: "ENV_ID_RES",
    headerName: "ID PICA",
    width: 100,
    editable: false,
    renderCell: (params) => {
      return <div className="ajustar-fila">{params.row.ENV_ID_RES}</div>;
    },
  },
  {
    field: "ENV_ESTAT_RES",
    headerName: "ESTAT PICA",
    width: 200,
    editable: false,
    cellClassName: (params) => {
      const valorRow = params.row.ENV_ESTAT_RES;
      if (valorRow != null) {
        const estado = params.value.toLowerCase();
        switch (estado) {
          case "Error PICA":
          case "Rebutjada sense acció":
          case "Rebutjada sense accés":
            return "estat-ERROR";
          case "Dipositada":
            return "estat-PENDENT";
          case "DipositadaEACAT":
            return "estat-Eacat";
          case "Acceptada":
            return "estat-OK";
          default:
            return "";
        }
      }
    },
    renderCell: (params) => {
      const backgroundColorMap = {
        "Error PICA": "#f44336",
        "Rebutjada sense acció": "#f44336",
        Dipositada: "#ff9800",
        Acceptada: "#4caf50",
        DipositadaEACAT: "#4286b9",
        "Rebutjada sense accés": "#f44336",
      };
      return (
        <div
          style={{
            backgroundColor: backgroundColorMap[params.value] || "",
            color: "white",
            textAlign: "center",
            borderRadius: 4,
            width: "90%",
            padding: 1,
          }}
        >
          {params.row.ENV_ESTAT_RES}
        </div>
      );
    },
  },
  {
    field: "ENV_ESTAT",
    headerName: "ESTAT PETICIO",
    width: 200,
    editable: false,
    renderCell: (params) => {
      return <div className="ajustar-fila">{params.row.ENV_ESTAT}</div>;
    },
  },
  {
    field: "ENV_ID_MIT",
    headerName: "ID ENVIAMENT",
    width: 150,
    editable: false,
    renderCell: (params) => {
      return <div className="ajustar-fila">{params.row.ENV_ID_MIT}</div>;
    },
  },
  {
    field: "ID_OCURRENCIA",
    headerName: "ID OCURRENCIA",
    width: 200,
    editable: false,
    renderCell: (params) => {
      return <div className="ajustar-fila">{params.row.ID_OCURRENCIA}</div>;
    },
  },
  {
    field: "ENV_GTF",
    headerName: "GTF USER",
    width: 200,
    editable: false,
    renderCell: (params) => {
      return <div className="ajustar-fila">{params.row.ENV_GTF}</div>;
    },
  },
];

export const columnsControlTramits = [
  {
    field: "TRAMIT",
    headerName: "TRAMIT",
    flex: 0.5,
  },
  {
    field: "MODALITAT",
    headerName: "MODALITAT",
    flex: 0.5,
  },
  {
    field: "BACKOFFICE",
    headerName: "BACKOFFICE",
    flex: 0.4,
  },
  {
    field: "DOCTRAM",
    headerName: "DOCTRAM",
    flex: 0.4,
  },
  {
    field: "CONTEXTCLASS",
    headerName: "CONTEXTCLASS",
    flex: 2,
  },
];

export const columnsPathXML = [
  {
    field: "NSRE",
    headerName: "NSRE",
    //flex: 1,
  },
  {
    field: "APLICACIO",
    headerName: "APP",
    //flex: 1,
  },
  {
    field: "TRAMIT",
    headerName: "TRAMIT",
    //flex: 1,
  },
  {
    field: "MODALITAT",
    headerName: "MODALITAT",
    //flex: 1,
  },
  {
    field: "ID_VARIABLE_OK",
    headerName: "ID_OK",
    //flex: 1,
  },
  {
    field: "ID_VARIABLE_KO",
    headerName: "ID_KO",
    //flex: 1,
  },
  {
    field: "NOM",
    headerName: "NOM",
    //flex: 2,
  },
  {
    field: "PATH_XML",
    headerName: "PATH_XML",
    //flex: 10,
  },
  {
    field: "CODI",
    headerName: "CODI",
    //flex: 1,
  },
  {
    field: "TIPUS",
    headerName: "TIPUS",
    //flex: 1,
  },
];

export const columnsTrazabilidad = [
  {
    field: "TRAP_ID_PARAM",
    headerName: "ID PARAM",
    editable: false,
    flex: 0.8,
    renderCell: (params) => {
      return <div className="ajustar-fila">{params.id}</div>;
    },
  },

  {
    field: "TRAP_DESC_VALOR",
    headerName: "DESCRIPCIO",
    editable: false,
    flex: 1.8,
    renderCell: (params) => {
      return (
        <div style={{ textAlign: "left", overflow: "auto" }}>
          {params.row.descValor}
        </div>
      );
    },
  },
  {
    field: "TRAP_VALOR",
    headerName: "VALOR",
    editable: false,
    flex: 4,
    renderCell: (params) => {
      return <CellValorTrazabilidad valor={params.row.valor} />;
    },
  },
];

const safeText = (v) => (v !== null && v !== undefined ? v : "");
const safeDash = (v) => (v !== null && v !== undefined && v !== "" ? v : "—");

const CellText = ({ value }) => (
  <Typography variant="body2" noWrap className="ajustar-fila">
    {safeText(value)}
  </Typography>
);

const CellNumber = ({ value }) => (
  <Box sx={{ width: "100%", textAlign: "right" }} className="ajustar-fila">
    {safeText(value)}
  </Box>
);

const CellStatus = ({ value }) => {
  const v = safeText(value);
  const bg = calculateEstatColorText(v);

  return (
    <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
      <Chip
        size="small"
        label={safeDash(v)}
        sx={{
          minWidth: 84,
          color: "white",
          backgroundColor: bg,
          fontWeight: 600,
        }}
      />
    </Box>
  );
};

export const columnsTraceServeis = [
  {
    field: "TRAS_ID_AUTO",
    headerName: "ID",
    width: 70,
    hide: true,
    sortable: true,
    valueGetter: (params) => params.row.id,
    renderCell: (params) => <CellNumber value={params.value} />,
  },
  {
    field: "TRAS_SERVEI",
    headerName: "Servei",
    flex: 1,
    minWidth: 140,
    editable: false,
    sortable: true,
    valueGetter: (params) => params.row.servei,
    renderCell: (params) => <CellText value={params.value} />,
  },
  {
    field: "TRAS_MODALITAT",
    headerName: "Modalitat",
    flex: 1,
    minWidth: 140,
    editable: false,
    sortable: true,
    valueGetter: (params) => params.row.modalitat,
    renderCell: (params) => <CellText value={params.value} />,
  },
  {
    field: "TRAS_ESTAT",
    headerName: "Estat",
    width: 120,
    editable: false,
    sortable: true,
    headerAlign: "center",
    align: "center",
    valueGetter: (params) => params.row.estat,
    cellClassName: (params) => calculateEstatClass(params.row.estat),
    renderCell: (params) => <CellStatus value={params.value} />,
  },
  {
    field: "TRAS_ESTAT_DOCTRAM",
    headerName: "Estat Doctram",
    width: 150,
    editable: false,
    sortable: true,
    headerAlign: "center",
    align: "center",
    valueGetter: (params) => params.row.estatDoctram,
    cellClassName: (params) => calculateEstatClass(params.row.estatDoctram),
    renderCell: (params) => <CellStatus value={params.value} />,
  },
  {
    field: "TRAS_ESTAT_TERCER",
    headerName: "Estat tercer",
    width: 140,
    editable: false,
    sortable: true,
    headerAlign: "center",
    align: "center",
    valueGetter: (params) => params.row.estatTercers,
    cellClassName: (params) => calculateEstatClass(params.row.estatTercers),
    renderCell: (params) => <CellStatus value={params.value} />,
  },
  {
    field: "TRAS_REINTENTS",
    headerName: "Reintents",
    width: 110,
    editable: false,
    sortable: true,
    headerAlign: "right",
    align: "right",
    valueGetter: (params) => params.row.reintents,
    renderCell: (params) => <CellNumber value={params.value} />,
  },
  {
    field: "TRAS_DATA_EXEC",
    headerName: "Data exec.",
    width: 140,
    editable: false,
    sortable: true,
    valueGetter: (params) => params.row.dataExec,
    renderCell: (params) => {
      const dateString = params.value;
      if (!dateString) return <CellText value={"—"} />;

      const fecha = moment(dateString);
      return (
        <Box className="ajustar-fila" sx={{ lineHeight: 1.2 }}>
          <Typography variant="body2">{fecha.format("DD/MM/YYYY")}</Typography>
          <Typography variant="caption" color="text.secondary">
            {fecha.format("HH:mm")}
          </Typography>
        </Box>
      );
    },
  },
  {
    field: "TRAS_TEMPS_TRANSCORREGUT",
    headerName: "Minuts",
    width: 90,
    editable: false,
    sortable: true,
    headerAlign: "right",
    align: "right",
    valueGetter: (params) => params.row.tempsTranscorregut,
    renderCell: (params) => <CellNumber value={params.value} />,
  },
  {
    field: "TRAS_DESC_ERR",
    headerName: "Error",
    width: 110,
    editable: false,
    sortable: false,
    filterable: false,
    renderCell: (params) => (
      <CellErrorTrazabilidad valor={renderText(params.row.descErr)} />
    ),
  },
  {
    field: "TRAS_DADES_PETICIO",
    headerName: "Petició",
    width: 180,
    editable: false,
    sortable: true,
    valueGetter: (params) => params.row.idPeticio,
    renderCell: (params) => {
      const raw = params.value;
      const text = renderText(raw);
      const truncatedText = truncateText(text, 16);

      return (
        <Tooltip title={raw ? `ID Petició: ${raw}` : ""}>
          <Typography variant="body2" noWrap className="ajustar-fila">
            {truncatedText || "—"}
          </Typography>
        </Tooltip>
      );
    },
  },
  {
    field: "TRAS_DADES_RETORN",
    headerName: "Retorn",
    width: 110,
    editable: false,
    sortable: false,
    filterable: false,
    renderCell: (params) => (
      <CellRetornTrazabilidad valor={renderText(params.row.dadesRetorn)} />
    ),
  },
  {
    field: "TRAS_REINICIAR_REINTENTS",
    headerName: "Reiniciar Reintents",
    width: 110,
    editable: false,
    sortable: false,
    filterable: false,
    headerAlign: "center",
    align: "center", 
    renderCell: (params) => {
      if(params.row.estatTercers === "KO" && params.row.reintents === 4) {
        return <CellReiniciarReintents trazaId={params.row.id} onReintentsReset={params.row.onReintentsReset} />
      }
      return null
    },
  }
  
];


const renderText = (text) => {
  if (!text) {
    return "N/A";
  }

  return text;
};

const calculateEstatClass = (value) => {
  let estado;
  switch (value) {
    case "ERROR":
      estado = "estat-ERROR";
      break;

    case "KO":
      estado = "estat-ERROR";
      break;

    case "PENDENT":
      estado = "estat-PENDENT";
      break;

    case "OK":
      estado = "estat-OK";
      break;

    default:
      estado = "";
  }
  return estado;
};

const calculateEstatColorText = (value) => {
  const colorTrasEstat = {
    ERROR: "#f44336",
    KO: "#f44336",
    PENDENT: "#ff9800",
    OK: "#4caf50",
  };

  return colorTrasEstat[value] || "";
};

const truncateText = (text, maxLength) => {
  if (text.length > maxLength) {
    return text.substring(0, maxLength) + "...";
  }
  return text;
};
